export default __webpack_public_path__ + "static/Canela-Regular-9f9fa8830678e5b8c921854a128bf83b.woff";